import secureLocalStorage from "react-secure-storage";
import api from "../../../../api/index";

export function customerFeedbackData(sd, ed, sd1, ed1,queryParams) {
  if(secureLocalStorage.getItem('id') =='00000000-0000-0000-0000-000000000001' ||secureLocalStorage.getItem('id') =='f9ba679b-a6b3-4cfc-85ef-af9d2dfd272c'){
    return api.get(`v2/engagements-summary/${sd}/${ed}/undefined?tab=slot_booking&sd=${sd1}&ed=${ed1}${queryParams}`);
  }
  else{
    return api.get(`v2/engagements-summary/${sd}/${ed}/${secureLocalStorage.getItem('id')}?tab=slot_booking&sd=${sd1}&ed=${ed1}${queryParams}`);
  }
}

export function summaryUser(){
  return api.get('users');
}
